export const BREAKPOINT = 849;
